import React from 'react';
import { AppProps } from 'next/app';
import { setCVID } from '@src/lib/cvid';

setCVID();

const App: React.FC<AppProps> = (props) => {
  const { pageProps, Component } = props;

  return <Component {...pageProps} />;
};

export default App;
